import { render, staticRenderFns } from "./ForaDoAr.vue?vue&type=template&id=425a62fa&scoped=true&"
import script from "./ForaDoAr.vue?vue&type=script&lang=js&"
export * from "./ForaDoAr.vue?vue&type=script&lang=js&"
import style0 from "./ForaDoAr.vue?vue&type=style&index=0&id=425a62fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a62fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425a62fa')) {
      api.createRecord('425a62fa', component.options)
    } else {
      api.reload('425a62fa', component.options)
    }
    module.hot.accept("./ForaDoAr.vue?vue&type=template&id=425a62fa&scoped=true&", function () {
      api.rerender('425a62fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/ForaDoAr/ForaDoAr.vue"
export default component.exports